module.exports = __webpack_public_path__ + "img/car-6.2fcbe040.png";